import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/paymentmethods`;

const paymentMethodsService = {
  // ✅ Get all payment methods (Admin use)
  getAll: async () => {
    const res = await axios.get(`${BASE_URL}`);
    return res.data;
  },

  // ✅ Get all methods by Publisher ID
  getByPublisher: async (publisherId) => {
    const res = await axios.get(`${BASE_URL}/getByPublisher/${publisherId}`);
    return res.data;
  },

  // ✅ Create a new payment method
  create: async (data) => {
    const res = await axios.post(`${BASE_URL}/create`, data);
    return res.data;
  },

  // ✅ Update an existing method
  update: async (id, data) => {
    const res = await axios.put(`${BASE_URL}/update/${id}`, data);
    return res.data;
  },

 SetMethodForInvoicing: async (id) => {
  const res = await axios.put(`${BASE_URL}/updateForInvoicing/${id}`);
  return res.data;
},

  // ✅ Delete a method
  delete: async (id) => {
    const res = await axios.delete(`${BASE_URL}/delete/${id}`);
    return res.data;
  },
};

export default paymentMethodsService;
